import React from "react";
import { Dialog, DialogActions, DialogContentText } from "@mui/material";
import { Button, DialogContent, DialogTitle } from "../";

interface BusinessHoursPopupProps {
  open: boolean;
  onClose: () => void;
}

export default function BusinessHoursPopup({ open, onClose }: BusinessHoursPopupProps) {
  return (
    <Dialog
      open={open}
      onClose={(e: any, reason: string) => {
        if (reason === "backdropClick") return;
        onClose();
      }}
      maxWidth={"lg"}
      disableEscapeKeyDown
    >
      <DialogTitle>운송 서비스 운영 시간 안내</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          <strong>지금은 카고콜 정상 근무 시간이 아닙니다.</strong>
          <br/>
          정상 근무 시간은 평일 <strong>오전 07시부터 오후 19시 / 토요일 오전 07시부터 오후 12시</strong> 까지 입니다.
          <br/>
          해당 시간 이외에 넣어주시는 상차 주문건은 원활한 배차 진행을 위하여 배차 주문 후 배차 담당자나 카고콜로 꼭 전화 부탁 드리겠습니다.
          <br/>
          감사합니다.
          <br/><br/>
          <strong>연락처 : 02-6012-5101 / 010-6216-5101</strong>
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>확인</Button>
      </DialogActions>
    </Dialog>
  );
}
